import { EditProfile } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.EDITPROFILE.path,
      name: "Edit Profile",
      key: routesMap.EDITPROFILE.path,
      commonRoute: false,
      private: true,
      withAuth: true,
      // belongsToSidebar: true,
      element: <EditProfile />,
    },
  ];
}
